

const UAVConfig = () => {
    const config = {
        sweepFreq: 1000,
        radius: 0.15,
        duration: 20000,
        cost: 15,
    }
    return config;
}

export default UAVConfig;